export const SET_WEBRTC_PUBLISH_WEBSOCKET="SET_WEBRTC_PUBLISH_WEBSOCKET";
export const SET_WEBRTC_PUBLISH_PEERCONNECTION="SET_WEBRTC_PUBLISH_PEERCONNECTION";
export const SET_WEBRTC_PUBLISH_PEERCONNECTION_AUDIO_SENDER="SET_WEBRTC_PUBLISH_PEERCONNECTION_AUDIO_SENDER";
export const SET_WEBRTC_PUBLISH_PEERCONNECTION_VIDEO_SENDER="SET_WEBRTC_PUBLISH_PEERCONNECTION_VIDEO_SENDER";
export const SET_WEBRTC_PUBLISH_CONNECTED="SET_WEBRTC_PUBLISH_CONNECTED";